<template>
  <div class="header">
<!--文案 -->
<div class="logo-section">
  <div class="logo-text">
    <div class="logo-title">河南科技成果与知识产权交易平台</div>
  </div>
</div>

<!-- 左侧tab -->
<div class="tabs">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="首页" name="1"></el-tab-pane>
 
    <el-tab-pane label="数据资源" name="3"></el-tab-pane>
    <el-tab-pane label="交易大厅" name="9"></el-tab-pane>
    <el-tab-pane label="特色产业" name="7"></el-tab-pane>
    <el-tab-pane label="科创金融" name="12"></el-tab-pane>
    <el-tab-pane label="知识产权运营服务" name="10"></el-tab-pane>
    <el-tab-pane label="科技成果转化" name="11"></el-tab-pane>
    <el-tab-pane label="知识图谱" name="15"></el-tab-pane>
    <el-tab-pane label="会员单位" name="13"></el-tab-pane>
 
    <el-tab-pane label="交易规则" name="8"></el-tab-pane>
    <el-tab-pane label="媒体中心" name="6"></el-tab-pane>

<!--     
    <el-tab-pane label="交易中心" name="2"></el-tab-pane>
    <el-tab-pane label="科创企业" name="4"></el-tab-pane>
    <el-tab-pane label="在线竞价" name="5"></el-tab-pane>




    <el-tab-pane label="科创金融" name="12"></el-tab-pane>

    <el-tab-pane label="路演大厅" name="14"></el-tab-pane> -->

    
  </el-tabs>
</div>

<!-- 右侧登录注册按钮 -->
<div class="auth-buttons">
  <el-dropdown v-if="userInfo" @command="handleUserCommand" trigger="click" placement="bottom-end">
    <span class="user-info-btn">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style="margin-right:6px;vertical-align:middle;">
        <circle cx="9" cy="6" r="3.5" stroke="rgba(255,255,255,0.9)" stroke-width="1.4"/>
        <path d="M2 17c0-3.866 3.134-7 7-7s7 3.134 7 7" stroke="rgba(255,255,255,0.9)" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
      {{ userInfo.nickName || userInfo.userName }}
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style="margin-left:4px;vertical-align:middle;">
        <path d="M3 4.5L6 7.5L9 4.5" stroke="rgba(255,255,255,0.7)" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="admin">管理后台</el-dropdown-item>
        <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
  <template v-else>
    <button class="auth-btn login-btn" @click="$router.push('/login?redirect=' + $route.fullPath)">登录</button>
    <div class="divider"></div>
    <button class="auth-btn register-btn" @click="registerDialogVisible = true">注册</button>
  </template>
</div>

<!-- 注册弹窗 -->
<el-dialog v-model="registerDialogVisible" title="注册账号" width="min(420px, 92vw)" :before-close="handleRegisterClose" class="register-dialog" append-to-body>
  <el-form ref="registerForm" :model="registerForm" :rules="registerRules" label-position="top">
    <el-form-item label="账号" prop="username">
      <el-input v-model="registerForm.username" placeholder="请输入账号"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="password">
      <el-input v-model="registerForm.password" :type="showPwd ? 'text' : 'password'" placeholder="请输入密码">
        <template #suffix>
          <svg @click="showPwd = !showPwd" style="cursor:pointer;width:18px;height:18px;" viewBox="0 0 24 24" fill="none">
            <template v-if="showPwd">
              <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z" stroke="#9CA3AF" stroke-width="1.8"/>
              <circle cx="12" cy="12" r="3" stroke="#9CA3AF" stroke-width="1.8"/>
            </template>
            <template v-else>
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
              <line x1="1" y1="1" x2="23" y2="23" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
            </template>
          </svg>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input v-model="registerForm.confirmPassword" :type="showConfirmPwd ? 'text' : 'password'" placeholder="请再次输入密码">
        <template #suffix>
          <svg @click="showConfirmPwd = !showConfirmPwd" style="cursor:pointer;width:18px;height:18px;" viewBox="0 0 24 24" fill="none">
            <template v-if="showConfirmPwd">
              <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z" stroke="#9CA3AF" stroke-width="1.8"/>
              <circle cx="12" cy="12" r="3" stroke="#9CA3AF" stroke-width="1.8"/>
            </template>
            <template v-else>
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
              <line x1="1" y1="1" x2="23" y2="23" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
            </template>
          </svg>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="姓名" prop="realName">
      <el-input v-model="registerForm.realName" placeholder="请输入真实姓名"></el-input>
    </el-form-item>
    <el-form-item label="联系方式" prop="contactPhone">
      <el-input v-model="registerForm.contactPhone" placeholder="请输入手机号码"></el-input>
    </el-form-item>
    <el-form-item label="所属企业" prop="enterpriseName">
      <el-input v-model="registerForm.enterpriseName" placeholder="请输入所属企业名称"></el-input>
    </el-form-item>
    <el-form-item style="margin-bottom:0;">
      <el-button
        type="primary"
        :loading="registerLoading"
        @click="submitRegister(true)"
        style="width:100%;height:40px;font-size:14px;font-weight:500;border-radius:6px;background:linear-gradient(90deg,#155DFC,#1447E6);border-color:#155DFC;"
      >注册并登录</el-button>
    </el-form-item>
  </el-form>
</el-dialog>

  </div>

  <div style="height:90px"></div>

    <IndexContent v-if="activeName=='1'" @switchTab="handleTabSwitch"></IndexContent>
<JyzxContent  v-if="activeName=='2'"  :idsss="activeName"></JyzxContent>
<sjzyContent v-if="activeName=='3'" :idsss="activeName" :initialTab="sjzyInitialTab"></sjzyContent>
<!-- <kcqyContent v-if="activeName=='4'"></kcqyContent> -->
<zxjjContent  v-if="activeName=='5'"></zxjjContent>
<mtzxContent  v-if="activeName=='6'"></mtzxContent>
<tscyContent  v-if="activeName=='7'"></tscyContent>
<jygzContent v-if="activeName=='8'"></jygzContent>
<jydtContent v-if="activeName=='9'" :idsss="activeName" :initialType="jydtInitialType"></jydtContent>
<zscqyyfwContent v-if="activeName=='10'"></zscqyyfwContent>
<kjcgzhContent v-if="activeName=='11'"></kjcgzhContent>
<kcjrContent  v-if="activeName=='12'" :idsss="activeName" :initialTab="kcjrInitialTab"></kcjrContent>
<hydwContent v-if="activeName=='13'" :idssss="activeName"></hydwContent>
<lydtContent v-if="activeName=='14'"></lydtContent>
<zstpContent v-if="activeName=='15'"></zstpContent>
<FootBut @updatemsg="handleMsg" :idssss="activeName" ></FootBut>

<!-- 右侧悬浮小程序按钮（常驻显示） -->
<div class="xcx-btn" @mouseenter="showQrcode = true" @mouseleave="showQrcode = false">
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="8" height="8" rx="1.5" stroke="white" stroke-width="2"/><rect x="13" y="3" width="8" height="8" rx="1.5" stroke="white" stroke-width="2"/><rect x="3" y="13" width="8" height="8" rx="1.5" stroke="white" stroke-width="2"/><rect x="5.5" y="5.5" width="3" height="3" fill="white"/><rect x="15.5" y="5.5" width="3" height="3" fill="white"/><rect x="5.5" y="15.5" width="3" height="3" fill="white"/><path d="M13 13h2v2h-2zM17 13h3v2h-3zM13 17h2v4h-2zM17 17h3v1h-3zM17 20h3v1h-3z" fill="white"/></svg>
  <span>小程序</span>
  <!-- 悬浮二维码弹出层 -->
  <transition name="fade">
    <div v-show="showQrcode" class="xcx-qrcode-popup">
      <img src="../assets/images/xcx.png" alt="小程序二维码" style="width:300px;height:300px;object-fit:contain;">
      <p style="margin:8px 0 0;font-size:12px;color:#374151;text-align:center;">扫码进入小程序</p>
    </div>
  </transition>
</div>

<!-- 右侧悬浮回到顶部按钮（仅首页显示） -->
<transition name="fade">
  <div
    v-show="activeName === '1' && showBackTop"
    class="back-top-btn"
    @click="goHome"
    title="回到顶部"
  >
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path d="M18 15L12 9L6 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>回到<br/>顶部</span>
  </div>
</transition>
  
</template>

<script>

import FootBut from '@/components/foot.vue'
import IndexContent from '@/components/index.vue'
import JyzxContent from '@/components/jyzx.vue'
import sjzyContent from '@/components/sjzy.vue'
import jydtContent from '@/components/jydt.vue'
import zscqyyfwContent from '@/components/zscqyyfw.vue'
import kjcgzhContent from '@/components/kjcgzh.vue'
// import kcqyContent from '@/components/kcqy.vue'
import zxjjContent from '@/components/zxjj.vue'
import mtzxContent from '@/components/mtzx.vue'
import tscyContent from '@/components/tscy.vue'
import jygzContent from '@/components/jygz.vue'
import kcjrContent from '@/components/kcjr.vue'
import hydwContent from '@/components/hydw.vue'
import lydtContent from '@/components/lydt.vue'
import zstpContent from '@/components/zstp.vue'

// import PcmxFrom from './pcmxfrom.vue'

import { getAction, postAction } from '@/api/requests'
import Cookies from 'js-cookie'

export default {
  name: 'HomeView',
  components: {
    FootBut,
    IndexContent,
    JyzxContent,
    sjzyContent,
    jydtContent,
    zscqyyfwContent,
    kjcgzhContent,
    // kcqyContent,
    zxjjContent,
    mtzxContent,
    tscyContent,
    jygzContent,
    kcjrContent,
    hydwContent,
    lydtContent,
    zstpContent
  },
  data(){
    return{
      activeName: '1',
      tabmoren:3,
      zwtab:1,
      sjzyInitialTab: '',
      kcjrInitialTab: '',
      jydtInitialType: '',
      userInfo: null,
      registerDialogVisible: false,
      registerLoading: false,
      showPwd: false,
      showConfirmPwd: false,
      registerForm: {
        username: '',
        password: '',
        confirmPassword: '',
        realName: '',
        contactPhone: '',
        enterpriseName: ''
      },
      registerRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' }
        ],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        enterpriseName: [{ required: true, message: '请输入所属企业', trigger: 'blur' }]
      },
      showBackTop: false,
      backTopHideTimer: null,
      showQrcode: false
    }
  },
  created(){
    if(this.$route.query.id){
      this.activeName = this.$route.query.id
    }
    this.checkLogin()
  },
  mounted() {
    this._scrollHandler = () => {
      if (window.scrollY > 300) {
        if (this.backTopHideTimer) {
          clearTimeout(this.backTopHideTimer)
          this.backTopHideTimer = null
        }
        this.showBackTop = true
      } else {
        if (!this.backTopHideTimer) {
          this.backTopHideTimer = setTimeout(() => {
            this.showBackTop = false
            this.backTopHideTimer = null
          }, 3000)
        }
      }
    }
    window.addEventListener('scroll', this._scrollHandler)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this._scrollHandler)
    if (this.backTopHideTimer) clearTimeout(this.backTopHideTimer)
  },
  methods:{
    handleRegisterClose() {
      this.registerDialogVisible = false
      this.$refs.registerForm && this.$refs.registerForm.resetFields()
      this.showPwd = false
      this.showConfirmPwd = false
    },
    submitRegister(andLogin) {
      this.$refs.registerForm.validate(valid => {
        if (!valid) return
        if (this.registerForm.confirmPassword !== this.registerForm.password) {
          this.$message.error('两次输入的密码不一致')
          return
        }
        this.registerLoading = true
        postAction('/register', {
          username: this.registerForm.username,
          password: this.registerForm.password,
          realName: this.registerForm.realName,
          contactPhone: this.registerForm.contactPhone,
          enterpriseName: this.registerForm.enterpriseName
        }).then(res => {
          this.registerLoading = false
          if (res.code === 200) {
            this.$message.success('注册成功')
            this.handleRegisterClose()
            if (andLogin) {
              this.$router.push({
                path: '/login',
                query: {
                  username: this.registerForm.username,
                  password: this.registerForm.password
                }
              })
            }
          } else {
            this.$message.error(res.msg || '注册失败')
          }
        }).catch(() => {
          this.registerLoading = false
          this.$message.error('注册失败，请稍后重试')
        })
      })
    },
    checkLogin() {
      const token = Cookies.get('Admin-Token')
      if (token) {
        getAction('/getInfo').then(res => {
          if (res.code === 200) {
            this.userInfo = res.user
          } else {
            // token 失效
            Cookies.remove('Admin-Token')
            this.userInfo = null
          }
        }).catch(() => {
          Cookies.remove('Admin-Token')
          this.userInfo = null
        })
      }
    },
    handleUserCommand(command) {
      if (command === 'admin') {
        window.open('https://hnipex.com/manage', '_blank')
      } else if (command === 'logout') {
        getAction('/logout').then(() => {}).catch(() => {})
        Cookies.remove('Admin-Token')
        this.userInfo = null
        this.$message.success('已退出登录')
      }
    },
    goHome() {
      this.activeName = '1'
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleMsg(val){
      console.log(val,'val');
this.activeName = val
},
    handleTabSwitch(tabName, initialTab = '') {
      console.log(tabName,'切换到 tab', initialTab);
      this.activeName = tabName
      window.scrollTo({ top: 0, behavior: 'smooth' })
      if(tabName === '3' && initialTab){
        this.sjzyInitialTab = initialTab
      }
      if(tabName === '12' && initialTab){
        this.kcjrInitialTab = initialTab
      }
      if(tabName === '9' && initialTab){
        this.jydtInitialType = initialTab
      }
    },
    handleClick(tab, event) {
        console.log(tab, event)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        // 切换 tab 时同步更新 URL query，便于登录后返回
        this.$router.replace({ path: '/', query: { id: tab.props.name } })
      },
      // 接口调用模版
    getapi(){
      let data = {
        pageNum: 1,
    pageSize: 10,
      }
      getAction("/edu/expert/list", data).then(res => {
        console.log(res)
     
      })
    }
  }
}
</script>

<style>

body{
  background-color: black;
}
::-webkit-scrollbar {width:0 !important;}
::-webkit-scrollbar{ width:0 !important;}

/* 注册弹窗圆角兜底（全局） */
.el-overlay .register-dialog .el-dialog {
  border-radius: 16px !important;
  overflow: hidden !important;
}

/* 注册弹窗样式 */
.register-dialog .el-dialog {
  border-radius: 10px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3) !important;
}
.register-dialog .el-dialog__header {
  background: #FFFFFF !important;
  padding: 20px 36px 8px !important;
  border-bottom: none !important;
  margin: 0 !important;
}
.register-dialog .el-dialog__title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #111827 !important;
}
.register-dialog .el-dialog__headerbtn {
  top: 12px !important;
  right: 16px !important;
  width: 28px !important;
  height: 28px !important;
  background: none !important;
}
.register-dialog .el-dialog__close {
  color: #9CA3AF !important;
  font-size: 20px !important;
}
.register-dialog .el-dialog__close:hover {
  color: #374151 !important;
}
.register-dialog .el-dialog__body {
  background: #FFFFFF !important;
  padding: 8px 32px 32px !important;
  max-height: calc(85vh - 120px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.register-dialog .el-dialog__footer {
  display: none !important;
}
/* 表单项间距 */
.register-dialog .el-form-item {
  margin-bottom: 22px !important;
}
/* 错误提示不被截断 */
.register-dialog .el-form-item__error {
  position: relative !important;
  margin-top: 2px !important;
}
/* label 样式 */
.register-dialog .el-form-item__label {
  color: #374151 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding-bottom: 6px !important;
}
/* 必填星号红色 */
.register-dialog .el-form-item.is-required .el-form-item__label::before {
  color: #EF4444 !important;
}
/* 输入框浅蓝灰背景 */
.register-dialog .el-input__wrapper {
  background: #EFF6FF !important;
  border: 1.5px solid #DBEAFE !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  padding: 4px 12px !important;
}
.register-dialog .el-input__wrapper:hover,
.register-dialog .el-input__wrapper.is-focus {
  border-color: #3B82F6 !important;
  box-shadow: none !important;
}
.register-dialog .el-input__inner {
  height: 40px !important;
  font-size: 15px !important;
  color: #1F2937 !important;
  background: transparent !important;
}
.register-dialog .el-input__inner::placeholder {
  color: #9CA3AF !important;
}

.header{
  background: linear-gradient( 360deg, rgba(0,23,47,0.5) 0%, rgba(0,1,2,0.5) 100%);
    backdrop-filter: blur(5px);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 0.4rem -1px;
    transition: opacity 0.7s ease-in-out;
box-sizing: border-box;
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  width: 100%; /* 元素宽度 */
  height:90px; /* 元素高度 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index:999;
}
.headertop{
  width: 100%;
  box-sizing: border-box;
  height: 70px;
  display: flex;
  justify-content:space-between;
  /* border-top: 1px solid var(---01, rgba(255, 255, 255, 0.08)); */
border-bottom: 1px solid var(---01, rgba(255, 255, 255, 0.08));

}
.nameimg{
  width: 97px;
  height: 40px;
  margin-left: 24px;
  margin-top: 15px;
}

.juznpcimg{
  width: 196px;
  height: 33px;
  margin-left: 16.5px;
  margin-top: 14px;
}
/* logo 区域样式 */
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 40px;
  flex-shrink: 0;
}

.logo-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.logo-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.logo-title {
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.logo-subtitle {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
}

.tabs{
  flex: 1;
  margin-left: 40px;
  margin-right: 20px;
  display: flex;
  align-items: center;
}

/* 右侧登录注册按钮 */
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 0;
  margin-right: 40px;
}

.auth-btn {
  padding: 8px 20px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s;
}

.auth-btn:hover {
  color: #FFFFFF;
}

.divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.3);
}

.login-btn {
  padding-right: 16px;
}

.register-btn {
  padding-left: 16px;
}

.user-info-btn {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s;
  outline: none;
}

.user-info-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}

</style>


<style scoped>

/* 去掉长分割线 */
:deep(.el-tabs__nav-wrap::after) {
  display: none !important;
}

/* 激活状态的下划线 */
:deep(.el-tabs__active-bar) {
  height: 3px;
  background: linear-gradient(90deg, #3B82F6 0%, #60A5FA 100%);
  border-radius: 2px;
}

/* 标签项样式 */
::v-deep .el-tabs {
  height: 100%;
  display: flex;
  align-items: center;
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__nav-wrap {
  display: flex;
  align-items: center;
}

::v-deep .el-tabs__item {
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 400;
  padding: 0 20px;
  height: 90px;
  line-height: 90px;
  transition: all 0.3s;
}

/* 标签项悬停 */
::v-deep .el-tabs__item:hover {
  color: #3B82F6;
}

/* 激活状态的标签 */
::v-deep .el-tabs__item.is-active {
  color: #3B82F6;
  font-weight: 500;
}

.zwtab{
  width: 124px;
  height: 42px;
  border-radius: 99px;
background: var(---03--, rgba(255, 255, 255, 0.12));
 display: flex;
 justify-content: space-around;
 align-items: center;
margin-top: 13px;

}

.zwtab1{
  width: 52px;
  height: 32px;
display: flex;
justify-content: center;
align-items: center;
color: rgba(255, 255, 255, 0.40);

}
.zwtab2{
  width: 52px;
  height: 32px;
  border-radius: 49px;
background: #1F5EFF;
display: flex;
justify-content: center;
align-items: center;
color: var(---white, var(---, #FFF));
font-family: "HarmonyOS Sans SC";
font-size: 14px;
font-style: normal;
font-weight: 400;

}
.zwtabs{
  width: 30px;
  height: 2px;
  background-color: #313C56;
}
.lefts{
  display: flex;
}
.rights{
  display: flex;
  margin-right: 24px;
}

/* 右侧悬浮按钮组 */
.xcx-btn {
  position: fixed;
  right: 0;
  bottom: 210px;
  z-index: 999;
  width: 101px;
  height: 76px;
  background: #1E5AF9;
  box-shadow: 0px 4px 6px -4px rgba(28, 57, 142, 0.2), 0px 10px 15px -3px rgba(28, 57, 142, 0.2);
  border-radius: 14px 0 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.xcx-btn:hover {
  transform: translateX(-5px);
  box-shadow: 0px 6px 10px -4px rgba(28, 57, 142, 0.4), 0px 15px 25px -3px rgba(28, 57, 142, 0.4);
}

.xcx-btn span {
  font-size: 0.7em;
  color: white;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
}

.xcx-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  filter: brightness(10);
}

.xcx-qrcode-popup {
  position: absolute;
  right: 110px;
  bottom: 0;
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  white-space: nowrap;
  z-index: 1000;
}

.back-top-btn {
  position: fixed;
  right: 0;
  bottom: 120px;
  z-index: 999;
  width: 101px;
  height: 76px;
  background: #1E5AF9;
  box-shadow: 0px 4px 6px -4px rgba(28, 57, 142, 0.2), 0px 10px 15px -3px rgba(28, 57, 142, 0.2);
  border-radius: 14px 0 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.back-top-btn:hover {
  transform: translateX(-5px);
  box-shadow: 0px 6px 10px -4px rgba(28, 57, 142, 0.4), 0px 15px 25px -3px rgba(28, 57, 142, 0.4);
}

.back-top-btn span {
  font-size: 0.7em;
  color: white;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
